import React, { useMemo, useState } from "react";
import Button from "../../../Elements/Button/Button";
import "./detalleEmpleadoVacaciones.css"

export default function DetalleEmpleadoVacaciones({ vacacionesTomadas = [] }) {
    const [expandedYear, setExpandedYear] = useState(null);

    // Agrupar vacaciones por año
    const gruposPorAnio = useMemo(() => {
        return (vacacionesTomadas || []).reduce((acc, vac) => {
            const { anio } = vac;
            if (!acc[anio]) acc[anio] = [];
            acc[anio].push(vac);
            return acc;
        }, {});
    }, [vacacionesTomadas]);

    const años = Object.keys(gruposPorAnio).sort((a, b) => b - a);

    return (
        <div className="vacaciones-accordion mb-4">
            <h5 className="mb-3">Historial de Vacaciones</h5>

            {años.length === 0 && (
                <div className="text-muted">No hay registros de vacaciones.</div>
            )}

            {años.map((anio) => (
                <div key={anio} className="accordion-item">
                    <Button
                        text={anio}
                        action={() => setExpandedYear(expandedYear === anio ? null : anio)}
                        color="blue"
                        fill
                    />
                    {expandedYear === anio && (
                        <div className="accordion-body">
                            <table className="table table-sm mb-3">
                                <thead>
                                    <tr>
                                        <th>Folio</th>
                                        <th>Días</th>
                                        <th>Fechas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {gruposPorAnio[anio].map((v, idx) => (
                                        <tr key={idx}>
                                            <td>{v.folio || "-"}</td>
                                            <td>{v.dias}</td>
                                            <td>{v.fechas ? v.fechas.join(", ") : "-"}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}
